export default __webpack_public_path__ + "static/media/arrow_frame_layout.f04cfc52.svg";